"use strict";import{tag as r}from"../custom-tag.js";export function starHalfFilledIcon({height:l=16,width:a=16,hidden:t=!1,title:e="Star half filled"}={}){return r`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${a}
      height=${l}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${t?"true":"false"}"
      role="img"
      aria-label="${e}"
    >
      <mask
        id="star-half-filled_svg__mask0_6875_6488"
        width="20"
        height="20"
        x="2"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="m21.497 8.833-6.198-.9-2.772-5.616-.043-.056a.6.6 0 0 0-.072-.095.6.6 0 0 0-.096-.074l-.055-.043c-.012-.005-.025-.004-.037-.01a.65.65 0 0 0-.447 0c-.012.005-.025.004-.038.01l-.057.045a.6.6 0 0 0-.093.071.6.6 0 0 0-.074.097l-.042.055L8.7 7.932l-6.198.901a.588.588 0 0 0-.325 1.003l4.484 4.372-1.06 6.172a.588.588 0 0 0 .855.62L12 18.085 17.544 21a.589.589 0 0 0 .853-.62l-1.06-6.172 4.485-4.372a.587.587 0 0 0-.325-1.003m-5.201 4.748a.59.59 0 0 0-.17.52l.91 5.303-4.763-2.503c-.015-.009-.033-.008-.049-.015A.7.7 0 0 0 12 16.84V3.906l2.38 4.824a.59.59 0 0 0 .443.322l5.325.774z"
        />
      </mask>
      <g mask="url(#star-half-filled_svg__mask0_6875_6488)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=starHalfFilled.js.map
